<template>
  <div>
    <v-row>
      <v-col cols="12" class="text-center">
        <b>Tipo de pregunta</b><br><v-icon>{{item.idCatTipoPreguntaNavigation.icono}}</v-icon> {{item.idCatTipoPreguntaNavigation.tipoPregunta}}
      </v-col>
    </v-row>
    
    <!-- Tipo Numerico (2) -->
    <v-row v-if="item.idCatTipoPregunta == 2">
      <v-col cols="12" md="3" class="text-center">
        <b>Valor Mínimo</b><br>{{item.valorMinimo}}
      </v-col>
      <v-col cols="12" md="3" class="text-center">
        <b>Valor Máximo</b><br>{{item.valorMaximo}}
      </v-col>
      <v-col cols="12" md="3" class="text-center">
        <b>¿Promediable?</b><br><v-icon>{{item.promediable == true ? "mdi-check" : "mdi-close" }}</v-icon>
      </v-col>
      <v-col cols="12" md="3" class="text-center">
        <b>¿Selector numérico?</b><br><v-icon>{{item.selectorNumerico == true ? "mdi-check" : "mdi-close" }}</v-icon>
      </v-col>
    </v-row>

    <v-row v-if="item.idCatTipoPregunta == 2 && item.selectorNumerico == true">
      <v-col cols="12" md="6" class="text-center">
        <b>Etiqueta Inicial</b><br>{{item.etiquetaInicial}}
      </v-col>
      <v-col cols="12" md="6" class="text-center">
        <b>Etiqueta Final</b><br>{{item.etiquetaFinal}}
      </v-col>
    </v-row>


    <!-- Tipo Respuestas múltiples (3, 4) -->
    <v-row v-if="item.idCatTipoPregunta == 3 || item.idCatTipoPregunta == 4">
      <!-- <v-col cols="12" md="6" class="text-center">
        <b>Grupo</b><br>{{item.grupo == null || item.grupo == "" ? "N/A" : item.grupo}}
      </v-col> -->
      <v-col cols="12" md="12" class="text-center">
        <b>Respuestas ordenadas en horizontal</b><br><v-icon>{{item.horizantal == true ? "mdi-check" : "mdi-close" }}</v-icon>
      </v-col>
    </v-row>

    <!-- Tipo Parámetro (6) -->
    <v-row v-if="item.idCatTipoPregunta == 6">
      <v-col cols="12" md="6" class="text-center">
        <b>Parámetro visible</b><br><v-icon>{{item.parametroVisible == true ? "mdi-check" : "mdi-close" }}</v-icon>
      </v-col>
      <v-col cols="12" md="6" class="text-center">
        <b>Tipo de parámetro</b><br>{{item.idCatParametroNavigation.nombreParametro}}
      </v-col>
    </v-row>

    <!-- Pregunta y respuesta dependientes -->
    <v-row v-if="item.idPreguntaDependiente != null && item.idPreguntaDependiente != undefined">
      <v-col cols="12" :md="item.idCatRespuestaDependiente == null ? 12 : 6" class="text-center">
        <b>Pregunta dependiente</b><br>{{item.idPreguntaDependienteNavigation.nombrePregunta}}
      </v-col>
      <v-col v-if="item.idCatRespuestaDependiente != null" cols="12" md="6" class="text-center">
        <b>Respuesta dependiente</b><br>{{item.idCatRespuestaDependienteNavigation.respuesta}}
      </v-col>
    </v-row>

    <!-- Imagen -->
    <v-row v-if="item.tieneImagen == true">
      <v-col cols="12" md="6" offset-md="3" class="text-center">
        <b>Imagen</b>
        <br>
        <v-skeleton-loader v-if="loadingImg" type="image" />
        <img v-else v-bind:src="imgPregunta" style="max-width:100%; max-height:200px;"></img>    
      </v-col>
    </v-row>

    <!-- Campos siempre activos -->
    <v-row>
      <v-col cols="12" md="6" class="text-center">
        <b>Habilitada</b><br><v-icon>{{item.habilitado == true ? "mdi-check" : "mdi-close" }}</v-icon>
      </v-col>
      <v-col cols="12" md="6" class="text-center">
        <b>Requerida</b><br><v-icon>{{item.requerida == true ? "mdi-check" : "mdi-close" }}</v-icon>
      </v-col>
    </v-row>

  </div>
</template>
<script>
import{ getImagenPreguntaByIdPregunta } from "@/api";

export default {
  name: "PreguntaSeccionEncuestaContent",
  components: {
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      loadingImg: false,
      imgPregunta: '',
    };
  },
  computed: {
    
  },
  beforeMount () {},
  async mounted () {

    if(this.item.tieneImagen == true){
      await this.obtenerImagenPreguntaByIdPregunta(this.item.idPregunta);
    }


  },
  methods: {
    async obtenerImagenPreguntaByIdPregunta () {

      var self = this;
      self.loadingImg = true;

      self.snackbarTexto = "";
      self.snackbarColor = "";
      self.snackbar = false;

      try {
        let response = await getImagenPreguntaByIdPregunta(self.item.idPregunta);

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "Consulta correcta") {
              this.imgPregunta = 'data:image/png;base64,' + response.data.data.docto;
            }
          } else {
            self.snackbarTexto = "PreguntaSeccionEncuestaContent: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
          }
        } else {
          self.error = "Error de red";
          self.snackbarTexto = "PreguntaSeccionEncuestaContent: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
        }
        self.loadingImg = false;
      } catch (e) {
        self.loadingImg = false;
        self.error = e;
        self.snackbarTexto = "PreguntaSeccionEncuestaContent: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }
    },
  }
};
</script>